import {
  mediaPipeInteractiveSegmenterModelUrl,
  mediaPipeVisionWasmUrl,
} from "./mediapipe-assets";

const fetchAsset = (url: string): Promise<void> =>
  fetch(url, {
    cache: "force-cache",
    mode: "cors",
  }).then((response) =>
    response.ok
      ? response.arrayBuffer().then(() => undefined)
      : Promise.reject(new Error(`MediaPipe asset request failed: ${url}`)),
  );

export const preloadMediaPipeAssets = (params: {
  readonly onStatus: (message: string) => void;
}): Promise<void> => {
  params.onStatus("MediaPipe WASMを事前取得しています");

  return fetchAsset(mediaPipeVisionWasmUrl)
    .then(() => {
      params.onStatus("MediaPipeモデルを事前取得しています");

      return fetchAsset(mediaPipeInteractiveSegmenterModelUrl);
    })
    .then(() => {
      params.onStatus("MediaPipeモデルの事前取得が完了しました");
    });
};
